import { createFileRoute } from '@tanstack/react-router'

import { GuaranteesPage } from '../../../../components/pages/guarantees-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/contract-guarantees')({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <GuaranteesPage />
    </PermissionChecker>
  ),
})
